import CreditDetails from "../CreditDetails";

interface CreditsTabContentProps {
    credits: Credits[] | null;
    artist_id: number;
}

const CreditsTabContent: React.FC<CreditsTabContentProps> = ({
    credits,
    artist_id
}) => {
    return (
        <div className="tab-credits">
            {credits && credits[0] ? (
                <div className="individual-credits">
                    <CreditDetails key={artist_id} artist_id={artist_id} credits={credits} />
                </div>
            ) : (
                <div className="empty-credits-content"> No credits found. </div>
            )}
        </div>
    );
};

export default CreditsTabContent; 